import React from 'react';

import { ButtonType, ButtonWidget } from '@tableau/widgets';

import { Messages } from '../../../codegen/Localize';
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { IDatasourceActions } from '../../../ts/ServerApi/types/IDatasourceActions';
import { isSingleEmbeddedDatasource } from '../ActionsMenu/EntityActions/IEntityActionHelpers';
import { hideLaunchEditOnMobile } from '../../utils/MobileHelper';
import { FeatureFlags } from '~src/ts/FeatureFlags';

export function createEditDataSourceButton(params: {
  readonly item: IContentInfo<'datasource'>;
  readonly actions: IDatasourceActions;
  readonly editDatasource: () => void;
}): JSX.Element {
 if (FeatureFlags.editPublishedDataSourceEnabled
  && !isSingleEmbeddedDatasource([ params.item ])
  && !hideLaunchEditOnMobile()
  && params.actions
  && params.actions.launchWebAuthoring
  && params.actions.editDatasource){
    return (
      <ButtonWidget
        children={Messages.editDatasource()}
        buttonType={ButtonType.Outline}
        handleClick={params.editDatasource}
        testId={'action-edit-datasource'}/>
    );
  }
}
